<div class="vertical basic-card">
  <h3 class="horizontal header">
    <div class="left button-container">
      <div class="horizontal">
        {{ task?.title ?? ' ' }}
        @if (canEdit) {
          <div class="edit-button">
            <app-popover-edit-text [content]="task?.title" (saveChange)="onTitleSaveClick($event)">
              Edit Title
            </app-popover-edit-text>
          </div>
        }
      </div>
    </div>
    <div class="middle">{{ getTimeRangeString() }}</div>
    <div class="right">
      <div>
        @if (getTotalPercentage() === 100) {
          <span
            nz-icon
            [ngStyle]="{ fontSize: '20px' }"
            [nzType]="'check-circle'"
            [nzTheme]="'twotone'"
            [nzTwotoneColor]="'#52c41a'"
          ></span>
        } @else {
          {{ getTotalPercentage() }}% Complete
        }
      </div>
    </div>
  </h3>
  @if (boardIdList) {
    @if (boardIdList!.length == 1 && mode === 'userAssignment') {
      <div class="grid-content">
        @for (sessionTemplate of unfinishedSessionTemplate(tableData()[0]); track $index) {
          @if (!sessionTemplate.highestSessionScore) {
            <app-session-template-card
              [sessionTemplate]="sessionTemplate.sessionTemplate"
              [selectable]="false"
            ></app-session-template-card>
          }
        }
      </div>
      @if (finishedSessionTemplate(tableData()[0])) {
        <nz-collapse [nzBordered]="false">
          <nz-collapse-panel [nzHeader]="'Finished Assignments'" [nzActive]="false">
            <div class="finished-session-template grid-content">
              @for (item of finishedSessionTemplate(tableData()[0]); track $index) {
                <app-session-template-card
                  [sessionTemplate]="item.sessionTemplate"
                  [selectable]="false"
                ></app-session-template-card>
              }
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      }
    } @else {
      <nz-table #basicTable [nzData]="tableData()" [nzShowPagination]="tableData().length > 10">
        <thead>
          <tr>
            <th [nzWidth]="'200px'" class="horizontal button-container">
              Assignees
              @if (canEdit) {
                <div
                  nz-popover
                  nzPopoverTitle="Edit Assignees"
                  [(nzPopoverVisible)]="isEditMembersVisible"
                  nzPopoverTrigger="click"
                  [nzPopoverContent]="editMembersContentTemplate"
                >
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    (click)="onEditMemberClick()"
                    [matTooltip]="'Edit Assignees'"
                  >
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
                  </button>

                  <ng-template #editMembersContentTemplate>
                    <div class="vertical">
                      <app-add-member-btn class="right" (memberChange)="onAddMemberClick($event)"></app-add-member-btn>
                      <ul nz-list [nzDataSource]="tableData()" nzBordered nzSize="large">
                        @for (item of tableData(); track item) {
                          <li nz-list-item>
                            <div class="horizontal seperate" [ngStyle]="{ width: '200px' }">
                              <app-board-icon-title [board]="item.member"></app-board-icon-title>
                              <button nz-button nzType="default" nzSize="small" (click)="onDeleteMemberClick(item)">
                                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                              </button>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                </div>
              }
            </th>
            @if (basicTable.data.length > 0) {
              @for (item of basicTable.data[0].sessionTemplateList; track $index) {
                <th [nzAlign]="'center'">{{ item.sessionTemplate.title }}</th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track $index) {
            <tr>
              <td><app-board-icon-title [board]="data.member"></app-board-icon-title></td>
              @for (sessionTemplate of data.sessionTemplateList; track $index) {
                @if (mode === 'completionReport') {
                  <td [nzAlign]="'center'">
                    @if (sessionTemplate.highestSessionScore) {
                      <span
                        nz-icon
                        [ngStyle]="{ fontSize: '24px', color: 'rgb(18 185 129)' }"
                        style="font-size: 24px"
                        class="material-symbols-rounded"
                        >check</span
                      >
                    } @else if (isOverDue()) {
                      <nz-tag nzColor="error">
                        <span nz-icon nzType="clock-circle"></span>
                        <span>Overdue</span>
                      </nz-tag>
                    } @else {
                      <nz-tag>Not Started</nz-tag>
                    }
                  </td>
                } @else if (mode === 'gradingReport') {
                  <td
                    class="score"
                    [nzAlign]="'center'"
                    [ngStyle]="{ backgroundColor: getCellColorByScore(sessionTemplate.highestSessionScore) }"
                  >
                    @if (sessionTemplate.highestSessionScore) {
                      {{ sessionTemplate.highestSessionScore }}
                    } @else if (isOverDue()) {
                      <nz-tag nzColor="error">
                        <span nz-icon nzType="clock-circle"></span>
                        <span>Overdue</span>
                      </nz-tag>
                    } @else {
                      <nz-tag>Not Started</nz-tag>
                    }
                  </td>
                }
              }
            </tr>
          }
        </tbody>
      </nz-table>
    }
  }
</div>
